import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from 'src/AppContext';
import { GetLicenseSystemAccessByUserIdInput, GetLicenseSystemAccessByUserIdPayload, ModuleName } from './generated/types';
import { LicenseSystemAccessViewModel, mapLicenseSystemAccessPayloadToViewModel } from 'src/components/userManagement/ColorProofGo/cpGo';


const query = `query getLsByUserId($input: GetLicenseSystemAccessByUserIdInput!) {
    getLicenseSystemAccessByUserId(input: $input) {
        licenseSystemAccessItems {
            licenseSystemId
            role
        }
    }
}`;

export const useGetLicenseSystemAccessByUserId = (userId: string | undefined, moduleName: 'ColorProofGo' | 'ColorCard') => {
    const context = useContext(AppContext);

    const input: GetLicenseSystemAccessByUserIdInput = {
        moduleName: ModuleName[moduleName],
        targetUserId: userId!,
    };

    return useQuery({
        queryKey: [`getLsByUserId-for-${moduleName}`, userId],
        queryFn: async (): Promise<LicenseSystemAccessViewModel[]> => {

            const response = await (context.api.graphql({ query, variables: { input } }) as Promise<{
                data: {
                    getLicenseSystemAccessByUserId: GetLicenseSystemAccessByUserIdPayload;
                };
            }>);

            return mapLicenseSystemAccessPayloadToViewModel(response.data.getLicenseSystemAccessByUserId);

        },
        enabled: !!userId,
        refetchOnWindowFocus: false,
    });
};
